<div class="m-3" *ngIf="true">
  <div class="w-80">
    <label class="super-compos-label-input">{{ 'generateDocWithModel' | translate }} :</label>
    <p-dropdown 
      [options]="modelesDocPoint"
      [style]="{'width':'100%'}"
      optionLabel="description" 
      [(ngModel)]="modele"
      [placeholder]="'selectModeles'|translate" 
      appendTo="body"
      [showClear]="true" 
      [filter]="true" 
      [virtualScroll]="true" 
      (onChange)="onSelectModel($event.value)"
      [itemSize]="30">
    </p-dropdown>
  </div>

  <div class="mt-3">
    <p-accordion [multiple]="true">
      <p-accordionTab *ngIf="errorCount > 0" class="accordionError accordion-tab-max-height" [selected]="false" [header]="errorCount + ' ' + ('error.errors' | translate)">
        <span class="mb-0 red-text d-flex align-items-center" *ngFor="let message of errorMessage">
          <p [innerHTML]="message" class="break-word"></p>
        </span>
      </p-accordionTab>
      <p-accordionTab *ngIf="successCount > 0" class="accordionSucces accordion-tab-max-height" [selected]="true" [header]="successCount + ' ' + ('success.success' | translate)">
        <span class="mb-0 green-text d-flex align-items-center" *ngFor="let message of successMessage">
          <p [innerHTML]="message" class="break-word"></p>
        </span>
      </p-accordionTab>
    </p-accordion>
  </div>

  <p-footer class="d-flex align-items-center justify-content-end">
    <super-button
      [disabled]="!modele || successCount === 0"
      styleClass="green mt-4"
      text="{{ 'btn.sendToISign' | translate }}"
      (click)="verifyBeforeGenerate()"></super-button>
  </p-footer>
</div>


<p-confirmDialog
  key="confirmIfDev">
</p-confirmDialog>